import $ from 'jquery';
import responsive from 'lib/responsive';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import blocks from 'lib/analytics/blocks/index';
import gxp from 'lib/gxp/index';
import langFromUrl from 'lib/util/langFromUrl';
import 'bootstrapCollapse';
import recentVehicles from 'features/recentVehicles';
import anPageLoadOverall from 'lib/analytics/pageloadOverall';
import anComponentView from 'lib/analytics/componentView';
import anClickManual from 'lib/analytics/click.manual';

var __lang = langFromUrl();

var footer = {
  load: function () {
    $('.footer-main-sub').attr('id', 'footer-main-sub-list');
    $('.js-footer-dropdown-mobile').on('click', '.js-footer-head', function (e) {
      if (responsive() === 'sm') {
        e.preventDefault();
        var $this = $(this);
        var $childMenu = $this.next('ul');
        var $openMenus = $('.js-footer-dropdown-mobile').children('ul.footer-main-sub.in');
        // close any other sub-menus that may be open
        $('.js-footer-head').not(this).removeClass('open');
        $('.js-footer-head').not(this).attr('aria-expanded', 'false');

        if ($this.hasClass('open')) {
          $this.removeClass('open');
          $this.attr('aria-expanded', 'false');
        } else {
          $this.addClass('open');
          $this.attr('aria-expanded', 'true');
        }

        $openMenus.collapse('hide');
        // Toggle this one
        $childMenu.collapse('toggle');
      }
    });

    if (__lang === 'es') {
      $('.js-footer-language a').attr('lang', 'en');
    } else {
      $('.js-footer-language a').attr('lang', 'es');
    }

    this.analyticsLoad();
    this.gxpLoad();
    this.initEnsightenPrivacy();
  },

  analyticsLoad: function () {
    var $scope = $('div[data-component-name="Footer"]');
    var vehicle = recentVehicles.getMostRecentVehicle();
    if (vehicle) {
      anAddContext(
        $scope,
        blocks.seriesBlock({
          series_code: vehicle.series,
          year: vehicle.year,
          grade: vehicle.trim || '',
          trim_code: vehicle.trimCode || ''
        })
      );
    }
    anAddContext($scope, blocks.sectionBlock('footer'));
    anClicks($scope);
  },

  // move to other bundle? Or output directly in footer.xsl, since we need an init on every page
  gxpLoad: function () {
    if (BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled') {
      gxp.garage.init();

      $(document).ready(function () {
        if ($('#gxp-rc-search').length) {
          gxp.reusableComp.searchInit();
        }

        if ($('#gxp-rc-details').length) {
          gxp.reusableComp.detailsInit();
        }

        if ($('#gxp-rc-sso').length) {
          gxp.reusableComp.ssoInit();
        }
      });
    }
  },

  initEnsightenPrivacy: function () {
    window.onload = function () {
      var ccpaLink = $('a#ccpa-link');
      var ensCancelBtn = $('#ensCancel');
      var ensSaveBtn = $('#ensSave');
      var switchBtn = $('label[for="Personalization CookiesSlide"] .switch');
      var consentCookieLinkText = 'Cookie_consent_turn_on';

      ensCancelBtn.on('click', function () {
        anAddContext(
          ensCancelBtn,
          blocks.sectionBlock('cookie_consent_options_module')
        );
        anClickManual(ccpaLink, ensCancelBtn);
      });

      ensSaveBtn.on('click', function () {
        anAddContext(
          ensSaveBtn,
          blocks.sectionBlock('cookie_consent_options_module')
        );
        anClickManual(ccpaLink, ensSaveBtn);
      });
      switchBtn.addClass('datalayer-link');
      switchBtn.click(function () {
        if (consentCookieLinkText === 'Cookie_consent_turn_off') {
          consentCookieLinkText = 'Cookie_consent_turn_on';
        } else {
          consentCookieLinkText = 'Cookie_consent_turn_off';
        }
        var switchBtnLinkBlocks = {
          link_type_title: 'cookie consent',
          link_button_action: 'cookie consent switch link',
          link_type: 'button',
          link_trigger: 'aa-link',
          content_section: 'cookie_consent_options_module'
        };
        switchBtn.attr('data-anctx', JSON.stringify(switchBtnLinkBlocks));
        switchBtn.data('linktext', consentCookieLinkText);
        anClickManual(ccpaLink, switchBtn);
      });
    };
    $(document).ready(function () {
      // the ccpa modal seems broken when running gulp watch on localhost..
      // the modal pops-up every screen and does not set the cookie properly,
      // use this below to disable the modal pop-up when using localhost,
      // the modal will still pop-up when clicking the button
      if (window.location.hostname === 'localhost') {
        document.cookie = 'MODAL_VIEWED=1';
      }
      var ccpaLink = $('a#ccpa-link');
      var gateway = window.gateway;
      if (gateway && gateway.isInitialized) {
        $(ccpaLink).on('click', function (e) {
          e.preventDefault();
          var $window = $(window);
          var $body = $('body');
          // Get the scroll distance from the link to the top as soon as the link is clicked
          var scrollDistance = $window.scrollTop();
          gateway.openModal();

          setTimeout(function () {
            anPageLoadOverall();
            anComponentView(
              e.target,
              blocks.sectionBlock('cookie_consent_options_module')
            );
          }, 0);
          if (responsive() === 'sm') {
            // this section fixes the issue with the body scrolling when the modal
            // is open (mobile only)
            $body.addClass('modal-open').addClass('ccpa-modal').css('top', scrollDistance * -1);
          }
          // ensButtons class is for both save and cancel, basically when the modal is closed
          var ensBtns = $('.ensButtons');
          ensBtns.on('click', function () {
            if (responsive() === 'sm') {
              $('body').removeClass('modal-open').removeClass('ccpa-modal').css('top', '');
              // Set the scroll position back to what it was
              $window.scrollTop(scrollDistance);
            }
          });
        });
      }
    });
  }
};

export default footer;
